<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47.055" height="22.23"
    viewBox="0 0 47.055 22.23">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_11566" data-name="Rectangle 11566" :width="width" :height="height" :fill="themeColor" />
      </clipPath>
    </defs>
    <g id="Other" transform="translate(0 0)">
      <g id="Group_27787" data-name="Group 27787" transform="translate(0 0)" clip-path="url(#clip-path)">
        <path id="Path_86991" data-name="Path 86991"
          d="M71.027,35.712a4.958,4.958,0,1,1,4.958-4.958,4.963,4.963,0,0,1-4.958,4.958m0-8.15a3.192,3.192,0,1,0,3.192,3.192,3.2,3.2,0,0,0-3.192-3.192"
          transform="translate(-34.53 -13.482)" :fill="themeColor" />
        <path id="Path_86992" data-name="Path 86992"
          d="M20.229,35.712a4.958,4.958,0,1,1,4.958-4.958,4.963,4.963,0,0,1-4.958,4.958m0-8.15a3.192,3.192,0,1,0,3.192,3.192,3.2,3.2,0,0,0-3.192-3.192"
          transform="translate(-7.981 -13.482)" :fill="themeColor" />
        <path id="Path_86993" data-name="Path 86993"
          d="M49.626,36.765H39.969a.883.883,0,1,1,0-1.766h9.657a.883.883,0,1,1,0,1.766"
          transform="translate(-20.428 -18.292)" :fill="themeColor" />
        <path id="Path_86994" data-name="Path 86994"
          d="M11.668,18.154H10.314a.884.884,0,0,1-.735-.393L7.432,14.543a.884.884,0,0,1-.031-.932l1.206-2.09V.883a.883.883,0,0,1,1.766,0V11.758a.883.883,0,0,1-.118.441l-1.05,1.82,1.581,2.37h.882a.883.883,0,1,1,0,1.766"
          transform="translate(-3.807 0)" :fill="themeColor" />
        <path id="Path_86995" data-name="Path 86995"
          d="M47.415,18.948a.883.883,0,0,1-.322-1.706l1.982-.776a.986.986,0,0,0,.364-.4L48.5,11.225a.871.871,0,0,0-.64-.676L39.672,8.493a.883.883,0,0,1-.45-.275L34.389,2.679a2.666,2.666,0,0,0-2.01-.914H8.885A.883.883,0,0,1,8.885,0H32.379A4.434,4.434,0,0,1,35.72,1.518l4.65,5.329,7.925,1.989a2.642,2.642,0,0,1,1.944,2.055l.982,5.088a.888.888,0,0,1-.019.414,2.727,2.727,0,0,1-1.4,1.684l-2.069.811a.876.876,0,0,1-.322.061"
          transform="translate(-4.182 0)" :fill="themeColor" />
        <path id="Path_86996" data-name="Path 86996"
          d="M2.126,15.122h-.5A1.626,1.626,0,0,1,0,13.5V5.539A1.626,1.626,0,0,1,1.624,3.914H2.676a.883.883,0,0,1,0,1.766h-.91v7.676h.36a.883.883,0,1,1,0,1.766"
          transform="translate(0 -2.046)" :fill="themeColor" />
        <path id="Path_86997" data-name="Path 86997"
          d="M41.563,11.625H24.574a3.391,3.391,0,0,1-3.289-2.556L20.77,7.043a.883.883,0,1,1,1.712-.435L23,8.633a1.627,1.627,0,0,0,1.577,1.226H41.563a.883.883,0,1,1,0,1.766"
          transform="translate(-10.841 -3.106)" :fill="themeColor" />
      </g>
    </g>
  </svg>

</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
